import { EnvironmentalCards } from "./AssessmentCards";
import type { InsightCategory } from "./InsightDetailDialog";

export default function AssessmentsSection({
  onOpenDetail,
}: {
  onOpenDetail: (category: InsightCategory) => void;
}) {
  return <EnvironmentalCards onOpenDetail={onOpenDetail} />;
}
